// ArcadeScene — animated neon arcade-room backdrop for the Login page, shown
// ONLY under the "arcade" theme (mirror of CyberRain.jsx). Pure decoration
// (pointer-events:none). Re-renders on theme change via useTheme, and swaps to
// a downscaled top-anchored framing on narrow (mobile) viewports.
import { useEffect, useState } from "react";
import { useTheme } from "../hooks/useTheme.js";
import { buildArcadeScene } from "../arcade-scene.js";

export default function ArcadeScene() {
  const { theme } = useTheme();
  const [narrow, setNarrow] = useState(
    typeof window !== "undefined" && window.innerWidth < 640
  );

  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (theme !== "arcade") return null;

  return (
    <div
      className="arcade-scene"
      aria-hidden
      dangerouslySetInnerHTML={{ __html: buildArcadeScene(narrow) }}
    />
  );
}
